<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：商户-商户管理
      -->
  <div class="user supplier-index-page clearfix">

    <!-- 工具栏：与下方列表分区，避免 float 导致 Tab/表格顶到按钮旁 -->
    <div class="supplier-index-toolbar">
      <div class="common-level-rail">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/supplier/supplier/add'">添加商户</el-button>
      </div>
    </div>
    <div class="common-seach-wrap supplier-index-search">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline supplier-index-search-form">
          <el-form-item label="商户ID">
            <el-input v-model="formInline.shop_supplier_id" placeholder="ID" clearable style="width: 100px;" />
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input v-model="formInline.search" placeholder="名称模糊搜索" clearable style="width: 140px;" />
          </el-form-item>
          <el-form-item label="登录账号">
            <el-input v-model="formInline.user_name" placeholder="超管账号" clearable style="width: 130px;" />
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="formInline.link_name" placeholder="联系人" clearable style="width: 110px;" />
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="formInline.link_phone" placeholder="手机号" clearable style="width: 130px;" />
          </el-form-item>
          <el-form-item label="所属行业">
            <el-select v-model="formInline.industry_code" placeholder="全部" clearable style="width: 130px;">
              <el-option
                v-for="item in industryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="加盟身份">
            <el-select v-model="formInline.franchisee_type" placeholder="全部" clearable style="width: 120px;">
              <el-option
                v-for="item in franchiseeTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="店铺类型">
            <el-select v-model="formInline.store_type" placeholder="全部" clearable style="width: 100px;">
              <el-option label="普通" :value="10" />
              <el-option label="自营" :value="20" />
            </el-select>
          </el-form-item>
          <el-form-item label="店铺状态">
            <el-select v-model="formInline.is_recycle" placeholder="全部" clearable style="width: 100px;">
              <el-option label="开启" :value="0" />
              <el-option label="禁用" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="保证金">
            <el-select v-model="formInline.status" placeholder="全部" clearable style="width: 110px;">
              <el-option label="已缴纳" :value="0" />
              <el-option label="申请退出" :value="10" />
              <el-option label="未缴纳" :value="20" />
            </el-select>
          </el-form-item>
          <el-form-item label="省/市/区">
            <el-cascader
              v-model="formInline.region_path"
              placeholder="全部"
              :options="regionOptions"
              :props="{ value: 'id', label: 'name', children: 'children', checkStrictly: true }"
              clearable
              style="width: 200px;"
            />
          </el-form-item>
          <el-form-item label="邀请码">
            <el-input v-model="formInline.inviter_code" placeholder="邀请码" clearable style="width: 110px;" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
    </div>

    <!--内容-->
    <div class="product-content supplier-index-body">
      <div class="table-wrap">
        <el-tabs v-model="activeCoopTab" class="supplier-coop-tabs" @tab-click="onCoopTabClick">
          <el-tab-pane label="全部商户" name="all" />
          <el-tab-pane
            v-for="item in cooperativeTabList"
            :key="item.value"
            :label="item.label"
            :name="item.value"
          />
        </el-tabs>
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shop_supplier_id" label="商户ID" width="90"></el-table-column>
          <el-table-column label="排序" width="120">
            <template slot="header">
              <span>排序</span>
              <el-tooltip content="数字越大越靠前，修改后自动保存" placement="top">
                <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: help;" />
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.sort"
                :min="0"
                :max="999999"
                size="mini"
                controls-position="right"
                style="width: 100px;"
                @change="val => onSortChange(scope.row, val)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商户名称"></el-table-column>
          <el-table-column prop="superUser.user_name" label="登录账号"></el-table-column>
          <el-table-column label="logo" width="80">
            <template slot-scope="scope">
              <el-image v-if="scope.row.logo" :src="scope.row.logo.file_path"  fit="fill" :preview-src-list="[scope.row.logo.file_path]"/>
            </template>
          </el-table-column>
          <el-table-column label="营业执照" width="80">
            <template slot-scope="scope">
              <el-image v-if="scope.row.business" :src="scope.row.business.file_path" fit="fill" :preview-src-list="[scope.row.business.file_path]"/>
            </template>
          </el-table-column>
          <el-table-column label="商户会员权益" min-width="150">
            <template slot-scope="scope">
              <template v-if="memberBenefitRow(scope.row)">
                <div>
                  <span
                    class="member-benefit-badge"
                    :class="[
                      'member-benefit-lv-' + memberBenefitLevel(scope.row),
                      { 'member-benefit-dimmed': scope.row.benefit_period_expired }
                    ]"
                  >
                    {{ memberBenefitName(scope.row) }}
                    <em class="member-benefit-id">ID:{{ scope.row.member_benefit_id }}</em>
                  </span>
                  <el-tag v-if="scope.row.benefit_period_expired" type="danger" size="mini" style="margin-top:4px;display:block;width:fit-content;">权益已失效</el-tag>
                  <el-tag v-else type="success" size="mini" style="margin-top:4px;display:block;width:fit-content;">权益有效</el-tag>
                </div>
              </template>
              <span v-else class="gray9">-</span>
            </template>
          </el-table-column>
          <el-table-column label="保证金" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="green">已缴纳</span>
              <span v-if="scope.row.status == 10">申请退出</span>
              <span v-if="scope.row.status == 20" class="gray">未缴纳</span>
            </template>
          </el-table-column>
          <el-table-column prop="link_name" label="联系人" width="90"></el-table-column>
          <el-table-column prop="link_phone" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="address" label="联系地址"></el-table-column>
          <el-table-column label="所属行业" width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ industryText(scope.row.industry_code) }}</template>
          </el-table-column>
          <el-table-column label="省/市/区" width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ regionText(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="合作意向" width="90">
            <template slot-scope="scope">{{ cooperativePurposeText(scope.row.cooperative_purpose_type) }}</template>
          </el-table-column>
          <el-table-column label="加盟身份" width="95">
            <template slot-scope="scope">{{ franchiseeTypeText(scope.row.franchisee_type) }}</template>
          </el-table-column>
          <el-table-column prop="inviter_code" label="邀请码" width="90"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="recycle(scope.row,0)" type="text" size="small" v-auth="'/supplier/supplier/edit'" v-if="scope.row.is_recycle==1" style="color:gray;">开启</el-button>
              <el-button @click="recycle(scope.row,1)" type="text" size="small" v-auth="'/supplier/supplier/edit'" v-else>禁用</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/supplier/supplier/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row.shop_supplier_id)" type="text" size="small" v-auth="'/supplier/supplier/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  import request from '@/utils/request';
  import {
    fetchSupplierEnumOptions,
    cooperativePurposeTabsFromOptions,
    displayCooperativePurpose,
    displayFranchiseeType,
    displayIndustry,
    FALLBACK_COOPERATIVE_PURPOSE_OPTIONS,
    FALLBACK_FRANCHISEE_TYPE_OPTIONS,
    FALLBACK_INDUSTRY_OPTIONS,
  } from '@/utils/supplierEnumOptions';
  export default {
    components: {},
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*门店列表数据*/
        storeList: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          shop_supplier_id: '',
          search: '',
          user_name: '',
          link_name: '',
          link_phone: '',
          inviter_code: '',
          cooperative_purpose_type: '',
          industry_code: '',
          franchisee_type: '',
          store_type: '',
          is_recycle: '',
          status: '',
          region_path: [],
          province_id: '',
          city_id: '',
          region_id: ''
        },
        activeCoopTab: 'all',
        cooperativeTabList: cooperativePurposeTabsFromOptions(FALLBACK_COOPERATIVE_PURPOSE_OPTIONS),
        cooperativePurposeOptions: [...FALLBACK_COOPERATIVE_PURPOSE_OPTIONS],
        franchiseeTypeOptions: [...FALLBACK_FRANCHISEE_TYPE_OPTIONS],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        logoImgs: [],
        businessImgs: [],
        // 省市区树（用于把 province_id/city_id/region_id 转成中文）
        regionOptions: [],
        // 所属行业等：sys_enum 拉取，失败用兜底（见 supplierEnumOptions.js）
        industryOptions: [...FALLBACK_INDUSTRY_OPTIONS]
      };
    },
    created() {
      Promise.all([
        this.loadRegionTree().catch(() => {}),
        fetchSupplierEnumOptions().then(opt => {
          this.industryOptions = opt.industryOptions
          this.cooperativePurposeOptions = opt.cooperativePurposeOptions
          this.franchiseeTypeOptions = opt.franchiseeTypeOptions
          this.cooperativeTabList = cooperativePurposeTabsFromOptions(opt.cooperativePurposeOptions)
        }).catch(() => {})
      ]).finally(() => {
        this.getTableList();
      });
    },
    methods: {
      onCoopTabClick(tab) {
        const name = tab.name || tab.paneName
        this.activeCoopTab = name
        this.formInline.cooperative_purpose_type = name === 'all' ? '' : name
        this.curPage = 1
        this.getTableList()
      },
      memberBenefitRow(row) {
        return row && Number(row.member_benefit_id) > 0
      },
      memberBenefitLevel(row) {
        const b = row && row.memberBenefit
        const lv = b && b.level != null ? parseInt(b.level, 10) : 0
        if (lv >= 1 && lv <= 4) return lv
        return 1
      },
      memberBenefitName(row) {
        const b = row && row.memberBenefit
        return (b && b.name) ? b.name : '权益'
      },
      regionText(row) {
        if (!row) return '-';
        const path = [row.province_id, row.city_id, row.region_id].filter(Boolean);
        if (!path.length) return '-';
        const text = this.getRegionTextByPath(path);
        return text || '-';
      },
      industryText(code) {
        return displayIndustry(code, this.industryOptions);
      },
      cooperativePurposeText(v) {
        return displayCooperativePurpose(v, this.cooperativePurposeOptions);
      },
      // 根据 id 路径获取“省/市/区”中文文本
      getRegionTextByPath(path) {
        if (!Array.isArray(path) || !path.length || !this.regionOptions || !this.regionOptions.length) {
          return '';
        }
        let curOptions = this.regionOptions;
        const labels = [];
        for (const id of path) {
          const node = (curOptions || []).find(item => String(item.id) === String(id));
          if (!node) break;
          labels.push(node.name);
          curOptions = node.children || [];
        }
        return labels.length ? labels.join(' / ') : '';
      },
      // 加载地区树
      loadRegionTree() {
        return request._get('/shop/region.region/tree').then(res => {
          this.regionOptions = res.data.list || [];
          return this.regionOptions;
        });
      },
      franchiseeTypeText(v) {
        return displayFranchiseeType(v, this.franchiseeTypeOptions);
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = Object.assign({}, this.formInline);
        const path = Params.region_path || [];
        Params.province_id = path[0] || '';
        Params.city_id = path[1] || '';
        Params.region_id = path[2] || '';
        delete Params.region_path;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        self.logoImgs = [];
        self.businessImgs = [];
        SupplierApi.supplierList(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = (res.data.list.data || []).map(item => {
              item.sort = item.sort != null && item.sort !== '' ? Number(item.sort) : 0;
              return item;
            });
            self.totalDataNumber = res.data.list.total;
            self.tableData.forEach(function(item) {
              if(item.business){
                self.businessImgs.push(item.business.file_path);
              }
              if(item.logo){
                self.logoImgs.push(item.logo.file_path);
              }
            });
          })
          .catch(error => {
            self.loading = false;
          });
      },
      getLogoList(index){
        return this.logoImgs.slice(index).concat(this.logoImgs.slice(0,index))
      },
      getBusinessList(index){
        return this.businessImgs.slice(index).concat(this.businessImgs.slice(0,index))
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      resetSearch() {
        this.formInline = {
          shop_supplier_id: '',
          search: '',
          user_name: '',
          link_name: '',
          link_phone: '',
          inviter_code: '',
          cooperative_purpose_type: this.formInline.cooperative_purpose_type,
          industry_code: '',
          franchisee_type: '',
          store_type: '',
          is_recycle: '',
          status: '',
          region_path: [],
          province_id: '',
          city_id: '',
          region_id: ''
        };
        this.curPage = 1;
        this.getTableList();
      },

      onSortChange(row, val) {
        const sort = val != null && val !== '' ? parseInt(val, 10) : 0;
        SupplierApi.supplierSetSort({
          shop_supplier_id: row.shop_supplier_id,
          sort: Number.isNaN(sort) ? 0 : sort
        }, true).then(() => {
          this.$message.success('排序已更新');
        }).catch(() => {
          this.getTableList();
        });
      },

      /*打开添加*/
      addClick() {
        this.$router.push('/supplier/supplier/add');
      },

      /*打开编辑*/
      editClick(row) {
        let self = this;
        let params = row.shop_supplier_id;
        this.$router.push({
          path: '/supplier/supplier/edit',
          query: {
            shop_supplier_id: params
          }
        })
      },
      /* 强制下架上架*/
      recycle(row,state){
        let self = this;
        let war="";
        if(state==1){
          war="禁止"
        }else if(state==0){
          war="开启"
        }
        self
          .$confirm("确认要"+war+"吗?", '提示', {
            type: 'warning'
          })
          .then(() => {
            SupplierApi.supplierRecycle({
              shop_supplier_id: row.shop_supplier_id,
              is_recycle:state
            }).then(data => {
              self.$message({
                message: war+'成功',
                type: 'success'
              });
              self.getTableList();
            });
          });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          SupplierApi.deleteSupplier({
              shop_supplier_id: row
            }, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，商户删除成功',
                  type: 'success'
                });
                self.getTableList();
              }
            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {
          self.loading = false;
        });
      }

    }
  };
</script>

<style lang="scss">
  .subject-wrap{overflow: initial;}
  .el-image{width: 60px;height: 60px;}

  /* 与用户列表一致：4 档权益配色（level 1～4） */
  .member-benefit-badge {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1.35;
    color: #fff;
    font-weight: 600;
  }
  .member-benefit-id {
    font-style: normal;
    font-weight: 400;
    opacity: 0.92;
    font-size: 11px;
    margin-top: 2px;
  }
  .member-benefit-lv-1 {
    background: linear-gradient(135deg, #909399 0%, #b1b6bd 100%);
  }
  .member-benefit-lv-2 {
    background: linear-gradient(135deg, #e6a23c 0%, #f0c78a 100%);
    color: #5c3d0a;
    .member-benefit-id { color: #5c3d0a; opacity: 0.85; }
  }
  .member-benefit-lv-3 {
    background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  }
  .member-benefit-lv-4 {
    background: linear-gradient(135deg, #f56c6c 0%, #f89898 100%);
  }
  .member-benefit-dimmed {
    opacity: 0.55;
    filter: grayscale(0.35);
  }
  .gray9 { color: #999; }

  /* 浮动工具栏单独一行，列表区清除浮动，避免 Tab 与「添加商户」同一行重叠 */
  .supplier-index-toolbar {
    width: 100%;
    margin-bottom: 8px;
  }
  .supplier-index-page {
    max-width: 100%;
    min-width: 0;
  }
  .supplier-index-search {
    width: 100%;
    max-width: 100%;
    margin-bottom: 12px;
    padding: 12px 12px 4px;
    background: #f5f7fa;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .supplier-index-search-form.el-form--inline {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    .el-form-item {
      display: inline-flex;
      flex-wrap: nowrap;
      align-items: center;
      margin-right: 12px;
      margin-bottom: 8px;
      vertical-align: top;
    }
    .el-form-item__label {
      flex-shrink: 0;
      padding-right: 8px;
    }
    .el-form-item__content {
      flex: 0 0 auto;
    }
  }
  .supplier-index-toolbar::after {
    content: '';
    display: table;
    clear: both;
  }
  .supplier-index-body {
    clear: both;
    margin-top: 8px;
  }
  .supplier-coop-tabs {
    margin-bottom: 16px;
    .el-tabs__header {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/index.vue